import '@ids/style-link';

import type { Action } from '../../global-types/Content';
import { useHandleCallback } from '../../hooks/useHandleCallback';
import { IdsIcon } from '../icon/Icon';

type LinkActionProps = {
  action: Action;
  dispatchActionEvent: (action: Action) => void;
};

function getLinkClassName(action: Action): string {
  if (action.actionType === 'button') {
    return `if button ${action.buttonType ?? 'filled'} size-w-100p`;
  }
  return 'if link standalone icon small mb-8';
}

function LinkAction({ action, dispatchActionEvent }: LinkActionProps) {
  const { mutate: sendCallback } = useHandleCallback();

  function handleOnClick(action: Action) {
    if (action.callback)
      sendCallback({
        url: `${action.callback.baseUrl ?? ''}${action.callback.callbackPath}`,
        payload: action.callback.payload,
      });
    dispatchActionEvent(action);
  }

  return (
    <div
      className={`if ${action.actionType === 'button' ? 'flex flex-column flex-start size-w-100p md-max-w-384' : ''}`}
    >
      <a
        key={action.text}
        className={getLinkClassName(action)}
        href={action.url ? action.url : ''}
        target={action.target ?? '_self'}
        onClick={() => handleOnClick(action)}
      >
        {action.text}
        {action.icon && <IdsIcon name={action.icon} size={action.actionType === 'button' ? 24 : 16} />}
      </a>
    </div>
  );
}

export default LinkAction;
